//import Webview from '@component/native/visible/Webview'
import {fetchInitData, VideoBridgeGetFileInfo, videoBridgeOpenUrl} from '../../src/api'
import * as md5Tool from 'blueimp-md5'
import {_compareVersion, _getPureSDKVersion} from "./m_base/util";
import {BYTEDANCE_REPLACEMENT_DOMAIN, EG_REPLACEMENT_DOMAIN, PRIVACY_URL_CN, PRIVACY_URL_EN} from "./enums/enum_domain"
import {MTG_AD_OPTIONS_FETCH_METHOD_MACRO} from "./enums/enum_base";

export function fireEvent(eventName, eventData) {
    var ev = document.createEvent('HTMLEvents')
    ev.initEvent(eventName, false, true)
    ev.param = eventData
    document.dispatchEvent(ev)
}

export function getWebview() {
    return new Webview()
}

/**
 * 注册全局属性
 * @param propertyName
 * @param property
 */
export function registerPublicProperty(propertyName, property) {
    window.mtg_public_property = window.mtg_public_property || {}
    window.mtg_public_property[propertyName] = property
}

/**
 * 获取全局属性
 * @param propertyName
 * @param property
 */
export function getPublicProperty(propertyName, property) {
    return window.mtg_public_property ? window.mtg_public_property[propertyName] : undefined
}

export function getUrlParams(url) {
    var i
    url = url || window.location
    url = url.indexOf ? url : url.toString()
    url = decodeURIComponent(url)

    var paramStringStart = url.indexOf('?') + 1,
        paramStringEnd = (url.indexOf('#') === -1) ? url.length : url.indexOf('#'),
        paramString = url.slice(paramStringStart, paramStringEnd),
        keysAndValues = paramString.split('&'),
        paramsObject = {}

    for (i = 0; i < keysAndValues.length; i++) {
        var keyValue = keysAndValues[i].split('=')

        if (keyValue[0].slice(-2) === '[]') {
            var key = keyValue[0].slice(0, -2)
            paramsObject[key] = paramsObject[key] || []
            paramsObject[key].push(keyValue[1])
        } else {
            paramsObject[keyValue[0]] = keyValue[1]
        }
    }

    return paramsObject
}

export function appendUrlParam(url, key, value) {
    let separator = url.indexOf('?') > -1 ? '&' : '?'
    let extraParam = `${separator}${key}=${value}`
    url += extraParam
    return url;
}

export async function getFilePathByRemoteUrl(url = '', unitId, type = 2) {
    console.log('获取 filePath : ')
    let filePath = {
        path: url
    }
    let resource = [{
        type,
        ref: url
    }]
    let filePathConfig = await VideoBridgeGetFileInfo({ unitId, resource })
    if (filePathConfig && filePathConfig.resource && filePathConfig.resource[0] && filePathConfig.resource[0][url] && filePathConfig.resource[0][url].path) {
        filePath = filePathConfig.resource[0][url]
        console.log('获取 filePath =====================> : ', filePath)
    } else {
        console.warn('获取 filePath 失败: ', { url, filePathConfig })
    }
    return filePath
}

export function device() {
    var u = navigator.userAgent;
    var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
    var isiOS = !!u.match(/.+Mac OS X/); //ios终端
    return {
        isAndroid: isAndroid,
        isiOS: isiOS
    }
}

export function getMousePosition(event) {
    var e = event || window.event;
    var x = e.pageX || e.clientX;
    var y = e.pageY || e.clientY;
    console.log('x: ' + x + '\ny: ' + y);
    return { 'x': x || 0, 'y': y || 0 };
}

export function getMouseScreenPosition(event) {
    var e = event || window.event;
    var x = e.screenX;
    var y = e.screenY;
    console.log('screenX: ' + x + '\n screenY: ' + y);
    return { 'x': x || 0, 'y': y || 0 };
}

//获取native需要的参数
export function getParams2Native({ deep_link, id, title, desc, package_name, icon_url, image_url, image_size, impression_url, video_url, video_length, video_size, video_resolution, video_end_type, playable_ads_without_video, ctype, adv_imp, ad_url_list, t_imp, adv_id, click_url, notice_url, fca, fcb, template, ad_source_id, app_size, click_mode, rating, landing_type, ctatext, c_ct, ttc_ct, link_type, guidelines, reward_amount, reward_name, offer_type, storekit_time, c_toi, imp_ua, c_ua, gh_id, gh_path, bind_id, ad_tracking }) {
    console.log('getParams2Native invoked.')
    let params =  {
        id,
        title,
        desc,
        package_name,
        icon_url,
        image_url,
        image_size,
        // impression_url,
        video_url,
        video_length,
        video_size,
        video_resolution,
        video_end_type,
        playable_ads_without_video,
        ctype,
        adv_imp,
        ad_url_list,
        t_imp,
        adv_id,
        notice_url,
        fca,
        fcb,
        template,
        ad_source_id,
        app_size,
        click_mode,
        rating,
        landing_type,
        ctatext,
        c_ct,
        ttc_ct,
        link_type,
        guidelines,
        reward_amount,
        reward_name,
        offer_type,
        storekit_time,
        c_toi,
        imp_ua,
        c_ua,
        gh_id,
        gh_path,
        bind_id,
        deep_link,
        click_url,
        ad_tracking: {
            // impression: ad_tracking.impression,
            click: ad_tracking && ad_tracking.click
        }
    };
    // if(deep_link){
    //     params.deep_link = deep_link
    // }else{
    //     params.click_url = click_url
    // }
    return params
}

//删除url参数
export function delParam(url, paramKey) {
    var urlParam = url.substr(url.indexOf("?") + 1);
    var beforeUrl = url.substr(0, url.indexOf("?"));
    var nextUrl = "";

    var arr = new Array();
    if (urlParam != "") {
        var urlParamArr = urlParam.split("&");

        for (var i = 0; i < urlParamArr.length; i++) {
            var paramArr = urlParamArr[i].split("=");
            if (paramArr[0] != paramKey) {
                arr.push(urlParamArr[i]);
            }
        }
    }

    if (arr.length > 0) {
        nextUrl = "?" + arr.join("&");
    }
    url = beforeUrl + nextUrl;
    return url;
}

export function checkScreenOrientation() {
    if (typeof window.orientation === 'number') {
        if (window.orientation === 0) {
            return 'portrait';
        }
        if (window.orientation === 90 || window.orientation === -90) {
            return 'landscape';
        }
    } else {
        return (window.innerWidth > window.innerHeight) ? 'landscape' : 'portrait';
    }
}

export function parseCode() {
    var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
    var charsto = 'vSoajc7dRzpWifGyNxZnV5k+DHLYhJ46lt0U3QrgEuq8sw/XMeBAT2Fb9P1OIKmC'

    var encode = function (input) {
        var tempVal = window.btoa(input)
        var code = ''
        tempVal = tempVal.split('')
        tempVal.map(function (val) {
            if (chars.indexOf(val) != -1) {
                code += charsto.split('')[chars.indexOf(val)]
            } else {
                code += val
            }
        })
        return code
    }

    var decode = function (input) {
        var tempVal = input
        var code = ''
        tempVal = tempVal.split('')
        tempVal.map(function (val) {
            if (charsto.indexOf(val) != -1) {
                code += chars.split('')[charsto.indexOf(val)]
            } else {
                code += val
            }
        })
        try {
            return window.atob(code)
        } catch (e) {
            return ''
        }
    }

    return {
        encode64: encode,
        decode64: decode
    }
}

export function isURL(str) {
    return !!str.match(/(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi)
}

export function pos_fun(src) {
    var win = window;
    var n = (+new Date()) + '.r' + Math.floor(Math.random() * 1000);
    var img = win[n] = new Image();
    img.onload = img.onerror = function () {
        win[n] = null;
    };
    img.src = src;
}

// 替换所有clickurl中的appflyerhost
// export function replaceAppFlyerHost(res) {
//     var token = window.AF_SDK && window.AFEVENT && window.AF_SDK.getToken(window.AFEVENT)
//     if (!token) return;

//     function replaceElement(ele) {
//         return ele.replace('[af_token]', token)
//     }

//     res.click_url = replaceElement(res.click_url);
//     res.notice_url = replaceElement(res.notice_url);
//     res.ad_tracking && res.ad_tracking.click && (res.ad_tracking.click = res.ad_tracking.click.map(function (item) {
//         return replaceElement(item)
//     }))
// }

export function sendAdtracking(url) {
    if (device().isiOS) return;
    if (!url) return;
    url = parseCode().decode64(url)
    if (isURL(url)) {
        pos_fun(url)
    }
}
/**
 * 判断当前 SDK 版本是否大于等于指定版本, 此方法假定版本号以小数点分隔, 并且只会对比前三部分的数字
 * @param {string} currentSDKVersion 当前 SDK 的版本号
 * @param {string} iosMin 要比较的 iOS 版本号, 如果当前为 iOS SDK, 则使用此版本号进行对比
 * @param {string} androidMin 要比较的 Android 版本号, 如果当前为 Android SDK, 则使用此版本号进行对比
 * @returns {boolean} 如果当前版本号大于等于指定版本, 返回 true, 否则返回 false
 */
function checkSDKVersion({ currentSDKVersion = '', iosMin = '', androidMin = '' } = {}) {
    // 确认数据合法性
    if (!currentSDKVersion || (!iosMin && !androidMin)) {
        return false
    }

    // 特殊兼容: 由于安卓某些版本可能返回 sdk_info: "MAL_9.6.0,3.0.1" 的形式, 所以需要对这种不规则的版本格式进行兼容
    if (device().isAndroid) {
        // 移除 , 后缀
        currentSDKVersion = currentSDKVersion.split(',')[0]
        // 移除渠道标识
        currentSDKVersion = removeAndroidChannelSuffix(currentSDKVersion);
    }

    // 清除多余前后缀
    let arrSDKVer = currentSDKVersion.split('_')[1].split('.')
    let arrMinVer

    // 确认要对比的平台(iOS/Android)
    if (device().isiOS) {
        arrMinVer = iosMin.split('.').map(item => Number(item))
    } else if (device().isAndroid) {
        arrMinVer = androidMin.split('.').map(item => Number(item))
    } else {
        // 无法确认当前系统, 始终返回 false
        return false
    }

    // 返回对比结果
    return arrSDKVer[0] > arrMinVer[0]
        ||
        arrSDKVer[0] > arrMinVer[0]
        && arrSDKVer[1] >= arrMinVer[1]
        ||
        arrSDKVer[0] >= arrMinVer[0]
        && arrSDKVer[1] >= arrMinVer[1]
        && arrSDKVer[2] >= arrMinVer[2]
}

/**
 * 安卓版本号对比
 * @param currentSDKVersion 当前的sdk版本
 * @param minVersion 做对比的sdk版本，
 * @returns {boolean} 如果currentSDKVersion版本号大于等于指定minVersion版本, 返回 true, 否则返回 false
 */
export function checkAndroidSDKVersion({ currentSDKVersion = '', minVersion = '' }) {
    return checkSDKVersion({ currentSDKVersion, androidMin: minVersion })
}
/**
 *
 * IOS版本号对比
 * @param currentSDKVersion 当前的sdk版本
 * @param minVersion 做对比的sdk版本，
 * @returns {boolean} 如果currentSDKVersion版本号大于等于指定minVersion版本, 返回 true, 否则返回 false
 */
export function checkIosSDKVersion({ currentSDKVersion = '', minVersion = '' }) {
    return checkSDKVersion({ currentSDKVersion, iosMin: minVersion })
}

/**
 * 把版本号最后一位 1/2 的渠道标识去掉，如果 minor 版本号只有一位，则不作处理，直接返回传入的版本号
 * @param currentSDKVersion 未移除渠道标识的版本号
 * @returns {string} 移除了渠道标识的版本号
 */
function removeAndroidChannelSuffix(currentSDKVersion) {
    if (currentSDKVersion === '') return currentSDKVersion

    /**
     * 注意:
     * 安卓的版本号有一个特殊的规则, 如果测试包为 12.2.0, 则 release 包的版本号会存在两个 12.2.01 和 12.2.02,
     * 最后额外附加的数字 1 和 2 代表 SDK 投放的渠道，1 用来发国内(12.2.01), 2 用来发国外(12.2.02),
     * 所以这里判断安卓版本号的时候, 需要把最后一位 1/2 的渠道标识去掉
     */
    let tmpVersion = currentSDKVersion.slice(0, -1)
    if (tmpVersion.slice(-1) === '.') {
        // console.warn('当前版本号后缀只有一位, 推测应该是安卓测试包, 不再尝试截取', {currentSDKVersion, tmpVersion})
    } else {
        // console.warn('当前版本号后缀大于 1 位，应该是安卓渠道包, 尝试截取', {currentSDKVersion, tmpVersion})
        currentSDKVersion = tmpVersion
    }
    return currentSDKVersion;
}

export function parseDom(html) {
    let ele = document.createElement('div')
    ele.innerHTML = html
    return ele.childNodes[0]
}

/**
 * 将传入的对象序列化为 url 参数形式的字符串
 * @param o 传入的对象
 * @returns {string} 返回的序列化后的字符串
 */
export function mergeParams(o) {
    let s = ''
    for (let k in o) {
        s += `&${k}=${o[k]}`
    }
    return s
}

/**
 * 生成并返回一些基础的页面上下文信息 - 同步
 */
export function getBaseTemplateContext() {
    let baseData = {}

    // 初始化时间戳 (timestamp)
    baseData.ts = Date.now()
    // 初始化 endcard 模板名称 (material id), 如 endv4, 3like.v4
    baseData.mid = getTemplateName()
    // 固定值 - 1表示endcard；2表示playable
    baseData.h5_type = 1
    // 标识当前页是否是 zip 包
    baseData.is_zip = isFromZip() ? 1 : 0
    // 标识 "二选一模板样式优化方案" 是否开启 (model_type=1~n), 1-n的数字表示开启/其他值表示关闭
    baseData.model_type = encodeURIComponent(getPageUrlParams('model_type'))
    // 标识 "二选一模板倒计时自动播放" 是否开启 (cltp=1~n), 1-n的数字表示开启/其他值表示关闭
    baseData.cltp = encodeURIComponent(getPageUrlParams('cltp'))
    // 标识 "二选一模板倒计时自动播放文案变更" 是否开启 (cltp_type=1/2), 数字表示具体的文案类型
    baseData.cltp_type = encodeURIComponent(getPageUrlParams('cltp_type'))
    // 标识 "二选一模板心跳上报" 是否开启 (xt=1), 1-n的数字表示开启/其他值表示关闭
    baseData.xt = encodeURIComponent(getPageUrlParams('xt'))
    // 标识 "二选一模板多语言只支持简繁英三种" 是否开启 (lg=default), default开启/其他值表示关闭
    baseData.lg = encodeURIComponent(getPageUrlParams('lg'))
    // 标识 "自动 storekit" 是否开启 (allow auto click), 1 开启/0 关闭
    baseData.alac = Number(getPageUrlParams('alac')) === 1 ? 1 : 0
    // 标识 "全屏可点" 是否开启 (allow endcard fullscreen click), 1 开启/0 关闭
    baseData.alecfc = Number(getPageUrlParams('alecfc')) === 1 ? 1 : 0
    // 标识 "猜你喜欢" 是否开启 (more offer), 1 开启/0 关闭
    baseData.mof = Number(getPageUrlParams('mof')) === 1 ? 1 : 0
    // 标识 "猜你喜欢" 是否在请求时请求动态的接口路径
    baseData.mof_req_path = getPageUrlParams('mof_req_path')
    // 标识 "批量上报" 是否开启, 1 开启/0 关闭
    baseData.n_imp = Number(getPageUrlParams('n_imp')) === 1 ? 1 : 0
    // 标识当前操作系统 - 1 安卓, 2 iOS, 0 other
    baseData.platform = device().isAndroid ? 1 : device().isiOS ? 2 : 0
    // 当前浏览器 ua
    baseData.ua = encodeURIComponent(navigator.userAgent)
    // 标识当前是否是单 webview 多 iframe 方案
    baseData.ifr = 1

    return baseData
}

/**
 * 获取 SDK 中基础的上下文信息
 */
export function getBaseSDKDataFromContext(SDKContext) {
    let baseSDKData = {}

    // 如果传入的 SDK 上下文为空, 则不再尝试拼装相关信息
    if (!SDKContext || !SDKContext.campaignList) {
        baseSDKData.baseSDKDataError = 1
        return baseSDKData
    }

    // 主 offer
    let mainCampaign = SDKContext.campaignList && SDKContext.campaignList[0]
    // 获取主 offer 的 request 维度 id
    let objImpUrl = parseUrl(mainCampaign.only_impression_url)
    let mainCampaignRequestId = objImpUrl && objImpUrl.params && objImpUrl.params.k

    // 主 offer id
    baseSDKData.offer_id = mainCampaign.id
    // 主 offer 的 request id
    baseSDKData.r_id = mainCampaignRequestId
    // 主 offer 所在的 unit id, android banner unit_id 位置为 unitSetting.unitId
    baseSDKData.parent_unit = SDKContext.unit_id || SDKContext.unitSetting.unitId
    // 主 offer 所在的 app id
    baseSDKData.app_id = SDKContext.device && SDKContext.device.appId
    // 国别码
    if (SDKContext.appSetting) {
        baseSDKData.country_code = SDKContext.appSetting.country_code
    }
    // SDK 版本
    // fix 安卓banner无sdk_info字段时解析上报数据sdk_version=[object Object]报错问题
    baseSDKData.sdk_version = SDKContext.sdk_info || (SDKContext.appSetting && SDKContext.appSetting.sdk_info) || getPageUrlParams('sdk_version')
    // 当前网络类型
    baseSDKData.network_type = SDKContext.device && SDKContext.device.network_type || ''
    // 当前网络类型
    baseSDKData.ad_type = mainCampaign.ad_type || '-1'

    return baseSDKData
}

/**
 * 获取当前 endcard 页的模板名称
 *
 * 描述:
 * 尝试从 pathname 拿去后缀的文件名作为模板名称
 *
 * @returns {string} 返回获取到的模板名称
 */
export function getTemplateName() {
    let templateName = ''

    try {
        let filename = location.pathname.match(/\/[^\/]+(?=(\.\w+$))/)[0].substr(1)
        if (filename.length > 0) {
            templateName = filename
        }
    } catch (e) {
        console.warn('get tpl name err: ',e)
    }

    return templateName
}

// 用来标识当前页面是否来自 zip 包, 如果是 file: 协议则认为当前页面是从本机解压的 zip 包中打开的
export function isFromZip() {
    return location.protocol === 'file:'
}

/**
 * 获取 url 上的参数值
 * @param {string} key
 * @returns {*}
 * @private
 */
export function getPageUrlParams(key, url = location.href) {
    return parseUrl(url).params[key]
}

/**
 * 获取指定的模板开关，优先从本地变量获取（由服务端填充），其次从url参数中获取
 * @param name
 * @param mtgAdOptions
 * @param mtgAdOptionsFetchMethod
 * @returns {string}
 */
export function getAdOption(name, mtgAdOptions = window && window.MTG_AD_OPTIONS, mtgAdOptionsFetchMethod = window && window.MTG_AD_OPTIONS_FETCH_METHOD) {
    let result
    if (mtgAdOptionsFetchMethod === MTG_AD_OPTIONS_FETCH_METHOD_MACRO) {
        result = mtgAdOptions[name]
    } else {
        result = getPageUrlParams(name)
    }
    return result
}

export function parseUrl(url = location.href) {
    let a = document.createElement('a')
    a.href = url
    return {
        source: url,
        protocol: a.protocol.replace(':', ''),
        host: a.hostname,
        port: a.port,
        query: a.search,
        params: (function () {
            let ret = {}
            let seg = a.search.replace(/^\?/, '').split('&')
            let len = seg.length
            let i = 0
            let s
            for (; i < len; i++) {
                if (!seg[i]) {
                    continue
                }
                s = seg[i].split('=')
                ret[s[0]] = s[1]
            }
            return ret
        })(),
        file: (a.pathname.match(/\/([^\/?#]+)$/i) || [, ''])[1],
        hash: a.hash.replace('#', ''),
        path: a.pathname.replace(/^([^\/])/, '/$1'),
        relative: (a.href.match(/tps?:\/\/[^\/]+(.+)/) || [, ''])[1],
        segments: a.pathname.replace(/^\//, '').split('/')
    }
}

export function fetchDataByAjax(type, url, data, success, failed) {
    // 创建ajax对象
    var xhr = null
    if (window.XMLHttpRequest) {
        xhr = new XMLHttpRequest()
    } else {
        xhr = new ActiveXObject('Microsoft.XMLHTTP')
    }

    type = type.toUpperCase()
    // 用于清除缓存
    // var random = Math.random()

    if (typeof data == 'object') {
        var str = ''
        for (var key in data) {
            str += key + '=' + data[key] + '&'
        }
        data = str.replace(/&$/, '')
    }
    type = type.toUpperCase()
    if (type == 'GET') {
        if (data) {
            xhr.open('GET', url + '?' + data, true)
        } else {
            xhr.open('GET', url, true)
        }
        xhr.send()

    } else if (type == 'POST') {
        xhr.open('POST', url, true)
        // 如果需要像 html 表单那样 POST 数据，请使用 setRequestHeader() 来添加 http 头。
        xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded")
        xhr.send(data)
    } else if (type == 'POSTJSON') {
        xhr.open('POST', url, true)
        // 如果需要像 html 表单那样 POST 数据，请使用 setRequestHeader() 来添加 http 头。
        xhr.setRequestHeader("Content-type", "application/json")
        xhr.send(data)
    }

    // 处理返回数据
    xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
            if (xhr.status == 200) {
                if (typeof xhr.responseText === 'string') {
                    success(xhr.responseText)
                } else {
                    success(xhr.responseText)
                }
            } else {
                if (failed) {
                    failed(xhr.responseText)
                }
            }
        }
    }
}

export function fetchDataByFetch (type, url, data, success, failed) {
  // init
  let method = type;
  let body = data;
  let headers = {};
  let mode = 'cors';
  if (type === 'POSTJSON') {
    method = 'post';
    headers["content-type"] = "application/json";
  }

  // action
  fetch(url, {headers, body, method, mode})
    .then(status)
    .then(json)
    .then(res => {
      console.error(res)
      success(res)
    })
    .catch(res => {
      console.error(res)
      failed(res)
    })

  function status (res) {
    if (res.status === 200) {
      return Promise.resolve(res)
    } else {
      return Promise.reject(new Error(res.statusText))
    }
  }

  function json (res) {
    return res.json()
  }
}

export function base64() {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
    const charsto = 'vSoajc7dRzpWifGyNxZnV5k+DHLYhJ46lt0U3QrgEuq8sw/XMeBAT2Fb9P1OIKmC'

    const encode = function (input) {
        let tempVal = window.btoa(input)
        let code = ''
        tempVal = tempVal.split('')
        tempVal.map(function (val) {
            if (chars.indexOf(val) != -1) {
                code += charsto.split('')[chars.indexOf(val)]
            } else {
                code += val
            }
        })
        return code
    }

    const decode = function (input) {
        let tempVal = input
        let code = ''
        tempVal = tempVal.split('')
        tempVal.map(function (val) {
            if (charsto.indexOf(val) != -1) {
                code += chars.split('')[charsto.indexOf(val)]
            } else {
                code += val
            }
        })
        return window.atob(code)
    }

    return {
        encode64: encode,
        decode64: decode
    }
}

export const md5 = md5Tool

export function getOsVersion(str) {
    let u = str || navigator.userAgent, version = ''
    if (u.indexOf('Mac OS X') > -1) {
        //ios
        let regStr_saf = /OS [\d._]*/gi
        let verinfo = u.match(regStr_saf)
        version = (verinfo + "").replace(/[^0-9|_.]/ig, '').replace(/_/ig, '.')
    } else if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {
        //android
        version = u.substr(u.indexOf('Android') + 8, u.indexOf("", u.indexOf("Android")) - u.indexOf('Android') - 8)
    } else if (u.indexOf('BB10') > -1) {
        //黑莓bb10系统
        version = u.substr(u.indexOf('BB10') + 5, u.indexOf("", u.indexOf("BB10")) - u.indexOf('BB10') - 5)
    } else if (u.indexOf('IEMobile')) {
        //windows phone
        version = u.substr(u.indexOf('IEMobile') + 9, u.indexOf("", u.indexOf("IEMobile")) - u.indexOf('IEMobile') - 9)
    }
    return version
}

/**
 * 获取本次点击相对于屏幕以及相对于自身所在webview的位置
 * @param {Event} event H5 click event
 * @param {Boolean} isAutoClick 是否为自动storekit点击
 * @returns {Object} {clickScreenPosition, windowStartPoint}
 */
export function getClickPosition(event, isAutoClick = false) {
    // click_url 替换
    let clickScreenPosition = getMouseScreenPosition(event)
    const clickPosition = getMousePosition(event)
    const startX = clickScreenPosition.x - clickPosition.x
    const startY = clickScreenPosition.y - clickPosition.y
    const windowStartPoint = {
        startX, startY
    }
    console.log("##windowStartPoint", windowStartPoint)
    console.log("计算前clickScreenPosition：", clickScreenPosition)

    const _scale = window.devicePixelRatio
    console.log("_scale", _scale)
    clickScreenPosition.scale = _scale

    // 安卓startX,startY返回dp需要乘scale，返回px则不乘scale，这里返回px,本身点击坐标需要乘scale
    if (device().isAndroid) {
        clickScreenPosition.x = +clickScreenPosition.x * _scale
        clickScreenPosition.y = +clickScreenPosition.y * _scale
    } else {
        clickScreenPosition.x = (+clickScreenPosition.x) * _scale
        clickScreenPosition.y = (+clickScreenPosition.y) * _scale
    }
    console.log("计算后clickScreenPosition：", clickScreenPosition)

    //  如果是自动storekit，重置坐标
    if (isAutoClick) {
        clickScreenPosition.x = -999
        clickScreenPosition.y = -999
        clickScreenPosition.isAutoClick = 1;
    }

    return { clickScreenPosition, windowStartPoint }
}

/**
 * 一个定时监听器, 支持设置最大时限
 * @param condition 执行 callback 的条件, 必须是一个可以执行函数, 以确保每次可以拿到最新的状态
 * @param callback 符合条件时就会执行 callback
 * @param timeoutCallback 监听超时的情况下才会执行的回调函数()
 * @param maxDuration 最大监听时限, 超过时限就会自动停止监听, 默认 5 秒
 * @param maxRepeatTimes 最大重复次数, 和 maxDuration 共同控制监听器, 任何一个条件满足均会停止走超时逻辑
 * @param interval 监听频率, 默认 100 毫秒
 */
export function watchdog ({
                              condition = () => false,
                              callback = () => {
                              },
                              timeoutCallback = () => {
                              },
                              maxDuration = 5000,
                              interval = 100
                          }) {
    if (condition && condition()) {
        console.log(`watchdog: 首次即满足条件中止, 当前还未 setInterval`, {condition: condition && condition()})
        callback()
    } else {
        let counter = 0
        let timerRepeat = null
        let timerOnce = null
        // 未超时的情况下循环调用 callback
        timerRepeat = setInterval(function () {
            ++counter
            if (condition && condition()) {
                console.log(`watchdog: 提前满足条件中止, 当前第${counter}次循环`, {condition: condition && condition()})
                clearTimeout(timerOnce)
                clearInterval(timerRepeat)
                callback()
            }
        }, interval)

        // 超时
        timerOnce = setTimeout(function () {
            console.log(`watchdog: 超时, 已经循环了${counter}次`, {condition: condition && condition()})
            clearInterval(timerRepeat)
            timeoutCallback()
        }, maxDuration)
    }
}

// 获取 unitId
export function getUnitId(res){
    let unitId = "";
    if(res.unitSetting && res.unitSetting.unitId){
        unitId = res.unitSetting.unitId;
    }else if(res.unit_id){
        unitId = res.unit_id
    }else if(res.campaignList[0]['unitId']){
        unitId = res.campaignList[0]['unitId'];
    }else{
        unitId = ""
    }
    return unitId
}

/**
 * 获取 initData
 * 直接从 window 上获取
 * 或者调用 sdk 来获取
 * @returns {Promise<unknown>}
 */
export function getInitData() {
    return new Promise((resolve, reject) => {
        if (window && window.initData) {
            resolve(window.initData)
        } else {
            fetchInitData().then((data) => {
                // console.log('sampling=> initdata', initData)
                if (data) {
                    resolve(data)
                } else {
                    reject('no_initData')
                }
            })
        }
    })
}

/**
 * 判断当前模板是否是 banner
 */
export function isBanner() {
    return getTemplateName().includes('banner')
}

/**
 * 判断是不是安卓高版本 sdk
 * >=  16.1.1 是高版本，< 16.1.1 是低版本
 */
export function isAndroidBigSDKVersion(initData) {
    let currentSDKVersion = initData && (initData.sdk_info || initData.appSetting && initData.appSetting.sdk_info) || ''
    let pureSDKVersion = _getPureSDKVersion(currentSDKVersion)
    let isBigVersion = _compareVersion(pureSDKVersion,'16.1.1') >= 0

    console.info(`sampling=> 安卓版本是${pureSDKVersion}, 是否大于等于 16.1.1 ${isBigVersion}`)
    return isBigVersion
}

/**
 * @description: 返回一个不含最大值，含最小值的随机数
 * @param min
 * @param max
 * @returns {number}
 */
function randomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min)) + min;
}

/**
 * @description: 抽样，可以指定抽样概率
 * @param percent 抽样概率, 数字类型
 * @param cb 抽样函数
 */
function sampling(percent, cb) {
    const n = randomInt(1, 101)
    console.info(`sampling=> 随机数为${n}, 概率为${percent}`)
    if (n <= percent) {
        console.info('sampling=> 随机数小于或等于指定概率，抽样成功')
        cb()
    }
}

/**
 * @description: 抽样上报函数, 根据 rid 来决定要不要上报
 * @param rid
 * @param percent 抽样概率
 * @param reportFunction 上报函数
 * @param data 上报数据
 */
export function samplingReport(rid, percent, reportFunction, data) {
    if (!window.samplingMap) {
        window.samplingMap = {}
    }

    if (!rid) {
        console.info('sampling=> 当前请求没有 rid, 不上报')
        return;
    }
    let doReport = samplingMap[rid]

    console.info('sampling=> 当前请求 rid: ', rid)
    console.info('sampling=> 是否请求上报: ', doReport)
    if (doReport) {
        console.info('sampling=> 上报')
        reportFunction(data)
    } else if (doReport === undefined) {
        console.info('sampling=> 开始抽样')
        samplingMap[rid] = false
        sampling(percent, () => {
            samplingMap[rid] = true
        })
        console.info('sampling=> 抽样结果', samplingMap[rid])
        if (samplingMap[rid]) {
            console.info('sampling=> 上报')
            reportFunction(data)
        } else {
            console.info('sampling=> 不上报')
        }
    } else {
        console.info('sampling=> 不上报')
    }
}

/**
 * 判断当前是否是自有艾滴升级之后的版本
 * @param sdkInfo 当前版本号
 * @returns {boolean}
 */
 export function isSupportBC  (sdkInfo) {
    let pureSDKVersion = _getPureSDKVersion(sdkInfo)
    if (device().isAndroid) {
        return _compareVersion(pureSDKVersion, '15.5.2') >= 0
    } else {
        return _compareVersion(pureSDKVersion, '6.8.1') >= 0
    }
}
/**
 * 根据 SDK 版本和当前 url keyName，确定请求 v3 时要拼接的自有艾滴的 keyName 和 Value
 * @param sdkInfo
 * @param device
 * @returns {{}}
 */
 export function getParamNbc ({sdkInfo, device} = {}) {
    let paramNbc = {}
    let isSDKSupportBC = isSupportBC(sdkInfo)
    let nBc = getPageUrlParams('n_bc')
    let isUseDeviceInnerInfo = false;
    var u = navigator.userAgent;
    var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
    console.log('paramNbc', isAndroid, device)
    if (isAndroid) {
        // 安卓的banner init接口无法获取到sdk_info，所以当device下有b或c时就直接用
        if (device.b || device.c) isUseDeviceInnerInfo = true;
        console.log('paramNbc', isUseDeviceInnerInfo)
    } else {
        if (isSDKSupportBC) isUseDeviceInnerInfo = true;
    }
    if (isUseDeviceInnerInfo) {
        if (device && typeof device.b === 'string' && device.b.length > 0) paramNbc.b = device.b
        if (device && typeof device.c === 'string' && device.c.length > 0) paramNbc.c = device.c
    } else if (nBc) {
        nBc = decodeURIComponent(nBc)
        let [b, c] = nBc && nBc.split(",")
        paramNbc = {b, c}
    }
    console.log('paramNbc', paramNbc)
    return paramNbc
}
function iosMofParams(initData) {
    let deviceInfo = initData.device;
    let p = {
        screen_size: deviceInfo.screen_size,
        skad: deviceInfo.skad,
    }
    if (deviceInfo.f) {
        p.f = deviceInfo.f;
    } else if (deviceInfo.tki) {
        p.tki = deviceInfo.tki;
    }
    return p;
}
function androidMofParams(initData) {
    let deviceInfo = initData.device;
    let p = {
        screen_size: `${deviceInfo.screen_width}x${deviceInfo.screen_height}`,
        web_env: deviceInfo.web_env,
        f: deviceInfo.f,
        brand: deviceInfo.brand,
        misk_spt: deviceInfo.misk_spt,
        dvi: deviceInfo.dvi,
    }
    return p;
}
export function getMoreOfferQueryParams (initData) {
    let notNullParams = {};
    let p = {};
    try {
        if (device().isiOS) {
            p = iosMofParams(initData)
        } else {
            p = androidMofParams(initData);
        }
        for (let i in p) {
            // 使用encodeURIComponent处理值，避免在发起请求时+号被解析成空格
            if (p[i] !== undefined) {
                notNullParams[i] = encodeURIComponent(p[i]);
            }
        }
    } catch(err) {
        p = {}
    }
    return notNullParams;
}

/**
 * 因EG地区对*.rayjump.com域名解析存在问题
 * 需将EG地区的*.rayjump.com => *.mintegral.net
 * @param {String} url 使用的url含域名
 * @param {Object} initData initData
 */
export function replaceDomainForEG(url, initData) {
    const ct = initData && initData.appSetting && initData.appSetting.country_code;
    if (url && ct === "EG") {
        for(let key in EG_REPLACEMENT_DOMAIN){
            url = url.replace(key, EG_REPLACEMENT_DOMAIN[key])
        }
    }
    console.log("EG domain replace", url)
    return url;
}

/**
 * 字节聚合域名合规需求-域名替换逻辑
 * 替换条件，init 接口返回数据的 device.re_domain==="1" 则替换，替换域名为默认h5固定写好的域名 BYTEDANCEREPLACEMENTDOMAIN
 * @param {String} url 使用的url含域名
 * @param {Object} initData initData
 */
export function replaceDomain(url,initData){
    const re_domain = initData && initData.device && initData.device.re_domain;
    if(url && re_domain === "1"){
        for(let key in BYTEDANCE_REPLACEMENT_DOMAIN){
            if(url.indexOf(key)>-1){
                url = url.replace(key,BYTEDANCE_REPLACEMENT_DOMAIN[key])
                break;
            }
        }
    }
    console.log("byte domain replace", url)
    return url
}
// 获取隐私页面地址
export function getPrivacyUrl(campaign) {
    // privacy_url的取值优先级：offer返回>setting下发>原先默认的url
    let initData = window.initData;
    let appSetting = initData.appSetting;
    let url = '';
    if (campaign && campaign.privacy_url) {
        url = campaign.privacy_url;
    } else if (appSetting && appSetting.adchoice_link){
        url = appSetting.adchoice_link;
    } else {
        switch (navigator.language.toLowerCase()) {
            case 'zh':
            case 'zh-cn':
                url = PRIVACY_URL_CN
                break
            case 'zh-hk':
            case 'zh-tw':
                url = PRIVACY_URL_CN
                break
            default:
                url = PRIVACY_URL_EN
                break
        }
        url = replaceDomain(url, window.initData)
    }
    console.log(`获取到的privacy_url为： ${url}`);
    return url;
}
export function openUrl(url) {
    let initData = window.initData;
    let pureSdkVersion = _getPureSDKVersion(initData.sdk_info)
    // 备忘：
    // canOpenWebview: iosMin: `6.3.0`, androidMin: `14.0.0`
    // canOpenBrowser: iosMin: `4.9.0`, androidMin: `9.6.0`
    if ((device().isiOS && _compareVersion(pureSdkVersion, '6.3.0')) || (device().isAndroid && _compareVersion(pureSdkVersion, '14.0.0'))) {
        // 当前版本支持在内置 webview 打开
        videoBridgeOpenUrl({type:2, url: url})
    } else {
        // 不支持，默认在外部浏览器打开
        videoBridgeOpenUrl({type:1, url: url})
    }
}

// 打开 Mintegral 隐私页
export function jumpToPrivacyPage ({campaign} = {}) {
    let privacyUrl = getPrivacyUrl(campaign);
    openUrl(privacyUrl);
}
export function checkCanShowNewFbToast (currentSDKVersion) {
    //    先支持ios的新版本点击隐私后触发反馈弹窗
    let pureSDKVersion = _getPureSDKVersion(currentSDKVersion)
    // ios 739开始支持新版本的反馈弹窗
    // let iosVer = '7.3.0';
    let iosVer = '7.3.9';
    let andVer = '16.4.8';
    // let andVer = '16.4.6';
    let isIosVersionSurpport = _compareVersion(pureSDKVersion, iosVer) >= 0;
    let isAndroidVersionSurpport = _compareVersion(pureSDKVersion, andVer) >= 0;
    console.log('checkCanShowNewFbToast', isAndroidVersionSurpport, pureSDKVersion)
    if (isIosVersionSurpport && device().isiOS) {
        return true;
    } else if(isAndroidVersionSurpport && device().isAndroid) {
        return true;
    } else {
        return false;
    }
}
